import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import tokens from '../theme/tokens';

// 접수 정보 — 접수번호와 단계별 시각, 배송 구분·차량. 완료 건은 인수 서명 이미지
const useStyles = makeStyles(() => ({
  root: {
    padding: '18px 20px',
    borderRadius: tokens.radiusLg,
    backgroundColor: tokens.surface,
    boxShadow: tokens.cardShadow,
  },
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    gap: 12,
    padding: '7px 0',
    '& + &': { borderTop: `1px solid ${tokens.lineSoft}` },
  },
  k: { flex: '0 0 auto', fontSize: 13, letterSpacing: -0.4, color: tokens.muted },
  v: { flex: 1, minWidth: 0, textAlign: 'right', fontSize: 14, fontWeight: 500, letterSpacing: -0.4, color: tokens.ink, fontVariantNumeric: 'tabular-nums', wordBreak: 'keep-all' },
  vStrong: { fontWeight: 700, color: tokens.primaryDark },
  sign: {
    marginTop: 14,
    paddingTop: 14,
    borderTop: `1px solid ${tokens.lineSoft}`,
  },
  signLabel: { display: 'block', marginBottom: 8, fontSize: 13, letterSpacing: -0.4, color: tokens.muted },
  signImg: {
    display: 'block',
    width: '100%',
    maxHeight: 180,
    objectFit: 'contain',
    borderRadius: 12,
    border: `1px solid ${tokens.line}`,
    backgroundColor: tokens.surface,
  },
}));

const monthDay = (s) => {
  const m = String(s || '').match(/^\d{4}-(\d{2})-(\d{2})[ T](\d{2}:\d{2})/);
  return m ? `${Number(m[1])}월 ${Number(m[2])}일 ${m[3]}` : String(s || '');
};

function TrackInfo({ order }) {
  const cs = useStyles();
  const t = order.times || {};
  const rows = [
    { k: '접수번호', v: order.serial_number, strong: true },
    { k: '접수', v: monthDay(t.order) },
    { k: order.phase === 'reserved' ? '출발 예정' : '배차', v: monthDay(order.phase === 'reserved' ? t.reserve : t.allocation) },
    { k: '픽업', v: monthDay(t.pickup) },
    { k: '완료', v: monthDay(t.complete) },
    { k: '배송 구분', v: order.express ? '급송' : order.car ? '일반' : '' },
    { k: '차량', v: order.car },
  ].filter((r) => r.v);

  return (
    <section className={cs.root}>
      {rows.map((r) => (
        <div key={r.k} className={cs.row}>
          <span className={cs.k}>{r.k}</span>
          <span className={`${cs.v} ${r.strong ? cs.vStrong : ''}`}>{r.v}</span>
        </div>
      ))}
      {order.sign && (
        <div className={cs.sign}>
          <span className={cs.signLabel}>인수 확인</span>
          <img className={cs.signImg} src={order.sign} alt="인수 서명" loading="lazy" />
        </div>
      )}
    </section>
  );
}

export default TrackInfo;
